<template>
  <div id="app">
    <div
      id="ReminderBox"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ReminderBox"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="lbl_ReminderTitle" class="modal-title">
              {{ $t("Reminder") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div id="lbl_ReminderContent" class="modal-body">
            <div class="form-row">
              <div class="form-group col">
                {{ errormessage }}
              </div>
            </div>

            <div class="form-row">
              <button
                class="btn btn-primary col-md-8"
                @click="onReminderCancel()"
                style="margin: auto"
              >
                {{ $t("OK") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="confirmBox"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="confirmBox"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="lbl_CriteriaTitle" class="modal-title">
              {{ $t("Forgot password") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div id="lbl_modalContent" class="modal-body">
            <div class="form-row">
              <div class="form-group col" style="text-align: center">
                {{ $t("ENTER THE EMAIL ADDRESS YOU USED FOR REGISTRATION") }}
                {{
                  $t(
                    "WE WILL SEND YOU THE PASSWORD VIA YOUR REGISTERED EMAIL ADDRESS"
                  )
                }}
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col">
                <input
                  type="text"
                  name="name"
                  class="form-control"
                  ref="email"
                  v-model="forgetemail"
                  :placeholder="$t('Email')"
                  @input="emailcheck()"
                  @keydown="onkeyDownHandler2"
                />
              </div>
            </div>
            <div class="form-row" style="padding-bottom: 10px">
              <button
                id="btn_modalOk"
                type="button"
                class="btn btn-primary"
                ref="resendemail"
                :disabled="disabled2"
                @click="onContinue()"
                style="margin: auto"
              >
                <span
                  class="spinner-border spinner-border-sm"
                  style="margin-right: 5px"
                  id="spin"
                  role="status"
                  aria-hidden="true"
                  ref="spin"
                  v-if="spinner2"
                >
                </span>
                {{ $t("Reset Password") }}
              </button>
            </div>
            <div class="form-row">
              <a href="#" @click="onCancel()" style="margin: auto">
                {{ $t("Back") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <canvas id="load" ref="load"></canvas>
    <div class="main-wrapper container">
      <Navbar
        :iconAction="action2 == 2 || action2 == 4 ? 0 : 1"
        :changeurl="changeurl()"
      ></Navbar>

      <nav
        class="navbar navbar-secondary"
        style="background-color: initial; box-shadow: 0 0px 0px rgb(0 0 0 / 0%)"
      >
        <div class="container">
          <h3 id="heading" ref="heading">
            {{ title }}
          </h3>
        </div>
      </nav>

      <!-- Main Content -->
      <div class="main-content">
        <section class="section">
          <div class="section-body">
            <div class="card col-md-6" style="margin: auto">
              <div class="card-header">
                <h4 id="content" ref="content" v-html="desc"></h4>
              </div>
              <div class="card-body">
                <form>
                  <input
                    class="form-control"
                    name="pwd"
                    id="pwd"
                    ref="pwd"
                    type="password"
                    v-model="pwd"
                    style="
                      display: inline;
                      width: 98%;
                      border-left: hidden;
                      border-left: hidden;
                      border-right: hidden;
                      border-top: hidden;
                      border-radius: 0.25rem;
                    "
                    @keydown="onkeyDownHandler"
                  />
                  <i
                    class="fa fa-eye-slash"
                    aria-hidden="true"
                    style="margin-left: -30px"
                    id="togglePassword"
                    ref="togglePassword"
                    @click="change_type"
                  ></i>
                </form>
                <span
                  id="pw_error"
                  ref="pw_error"
                  style="color: red; font-size: 10px; padding-left: 5px"
                ></span>
                <p style="text-align: left">
                  <a href="#" @click="showEmail()">{{
                    $t("Forgot password")
                  }}</a>
                </p>
                <button
                  class="btn btn-primary col-md-12"
                  id="sumbit"
                  ref="sumbit"
                  @click="sumbit()"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    id="spin"
                    role="status"
                    aria-hidden="true"
                    v-if="spinner"
                    style="padding-rigth: 10px"
                  ></span>
                  <span id="loading" ref="loading">{{ $t("Login") }}</span>
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<style>
#country_code {
  border: none;
  border-bottom: 1px solid #000000;
}

canvas {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  box-sizing: border-box;
  margin: 0;
  width: 100%;
  height: 100%;
}
</style>

<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";
import config from "@/config";
import Navbar from "@/components/Navbar.vue";

export default {
  components: { Navbar },
  data() {
    return {
      errormessage: "",
      forgetemail: null,
      phone: null,
      country_code: null,
      action: 0,
      count: 0,
      disabled: true,
      disabled2: true,
      register_option: null,
      spinner: false,
      spinner2: false,
      kdpmembernumber: null,
      k11vipcode: null,
      k11accountno: null,
      pwd: null,
      iskdp: null,
      isk11: null,
      action2: null,
      title: "",
      desc: "",
      callbackurl: null,
    };
  },
  created() {
    this.actionSetForceBlock(false);
    this.callbackurl = window.sessionStorage.getItem("callbackurl");
    this.action = window.sessionStorage.getItem("action");
    this.phone = window.sessionStorage.getItem("phone");
    this.country_code = window.sessionStorage.getItem("country_code");
    this.kdpmembernumber = window.sessionStorage.getItem("kdpmembernumber");
    this.k11vipcode = window.sessionStorage.getItem("k11vipcode");
    this.k11accountno = window.sessionStorage.getItem("k11accountno");
    this.iskdp = window.sessionStorage.getItem("iskdp");
    this.isk11 = window.sessionStorage.getItem("isk11");
    this.action2 = window.sessionStorage.getItem("action2");
    window.sessionStorage.clear();
    if (
      this.phone == null ||
      this.country_code == null ||
      (this.kdpmembernumber == null && this.k11vipcode == null)
    ) {
      window.location.href = "./";
    }

    if (this.k11vipcode == "null") {
      this.k11vipcode = null;
    }
    if (this.kdpmembernumber == "null") {
      this.kdpmembernumber = null;
    }
    if (this.k11accountno == "null") {
      this.k11accountno = null;
    }
    if (this.action2 == "2") {
      this.title = this.$t(
        "Register as a KLUB 11 Member and bind with K Dollar Program"
      );
      this.desc = this.$t("An existing K Dollar Program account is found");
      // +
      // "<br />" +
      // this.$t("Please login with your K Dollar Program password to proceed");
    } else if (this.action2 == "4" || this.action2 == "0") {
      this.title = this.$t("Confirm to bind with K Dollar Program");
      if (this.action2 == "4") {
        this.desc =
          this.$t("An existing KLUB 11 account is found") +
          "<br />" +
          this.$t("Please login with your KLUB 11 password to proceed");
      } else {
        this.desc = this.$t("An existing K Dollar Program account is found");
        //  +
        // "<br />" +
        // this.$t(
        //   "Please login with your K Dollar Program password to proceed"
        // );
      }
    } else if (this.action2 == "1") {
      this.title = this.$t(
        "Register as a KDP Member and bind with K Dollar Program"
      );
      this.desc =
        this.$t("An existing KLUB 11 account is found") +
        "<br />" +
        this.$t("Please login with your KLUB 11 password to proceed");
    } else {
      this.title = this.$t("Login with your K Dollar Program Account Password");
      this.desc = this.$t(
        "Please enter your password to continue for binding process"
      );
    }
  },
  updated() {
    if (this.action2 == "2") {
      this.title = this.$t(
        "Register as a KLUB 11 Member and bind with K Dollar Program"
      );
      this.desc = this.$t("An existing K Dollar Program account is found");
      // +
      // "<br />" +
      // this.$t("Please login with your K Dollar Program password to proceed");
    } else if (this.action2 == "4" || this.action2 == "0") {
      this.title = this.$t("Confirm to bind with K Dollar Program");
      if (this.action2 == "4") {
        this.desc =
          this.$t("An existing KLUB 11 account is found") +
          "<br />" +
          this.$t("Please login with your KLUB 11 password to proceed");
      } else {
        this.desc = this.$t("An existing K Dollar Program account is found");
        // +
        // "<br />" +
        // this.$t(
        //   "Please login with your K Dollar Program password to proceed"
        // );
      }
    } else if (this.action2 == "1") {
      this.title = this.$t(
        "Register as a KDP Member and bind with K Dollar Program"
      );
      this.desc =
        this.$t("An existing KLUB 11 account is found") +
        "<br />" +
        this.$t("Please login with your KLUB 11 password to proceed");
    } else {
      this.title = this.$t("Login with your K Dollar Program Account Password");
      this.desc = this.$t(
        "Please enter your password to continue for binding process"
      );
    }
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),
    ...mapGetters(["getIsBlock"]),
  },
  mounted() {},
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest",
    ]),
    ...mapActions("filters", ["actionFindNow", "actionFindNowById"]),
    ...mapActions(["actionSetForceBlock", "actionSetBlock"]),
    onCancel() {
      $("#confirmBox").modal("hide");
    },
    onkeyDownHandler(e) {
      if (e.keyCode === 13) {
        $(this.$refs.sumbit).focus();
        event.preventDefault();
        $(this.$refs.sumbit).click();
      }
    },
    changeurl() {
      window.sessionStorage.setItem("callbackurl", this.callbackurl);
    },
    emailcheck() {
      var email = $(this.$refs.email);
      let filter =
        /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (filter.test(email.val())) {
        this.disabled2 = false;
      } else {
        this.disabled2 = true;
      }
    },
    onReminderCancel() {
      $("#ReminderBox").modal("hide");
    },
    onContinue() {
      let vm = this;
      var forgettype;
      forgettype = "1";
      helper.loading();
      $(this.$refs.load).css("z-index", "2147483647");
      this.spinner2 = true;
      api.request(
        this,
        "post",
        "/migrationhub/member/forgetpassword",
        {
          parameters: {
            type: forgettype,
            email: this.forgetemail,
          },
        },
        function (r) {
          $(vm.$refs.load).css("z-index", 0);
          if (r.success) {
            vm.spinner2 = false;
            helper.done();
            vm.errormessage = vm.$t(
              "The reset password link send to your email"
            );
            $("#confirmBox").modal("hide");
            $("#ReminderBox").modal("show");
          } else {
            this.forgetemail = "";
            $("#confirmBox").modal("hide");
            vm.spinner2 = false;
            vm.errormessage =
              vm.$t("Something went wrong") +
              // " " +
              // vm.$t("Please try again later") +
              " " +
              r.msg[helper.getMappingLocale(vm.$i18n.locale)] +
              "(" +
              r.errorcode +
              ")";
            $("#ReminderBox").modal("show");
            helper.done();
          }
        },
        function (r) {
          vm.spinner2 = false;
          $(vm.$refs.load).css("z-index", 0);
          console.log(r);
          helper.done();
        },
        false,
        null
      );
    },
    onkeyDownHandler2(e) {
      if (e.keyCode === 13) {
        $(this.$refs.resendemail).focus();
        event.preventDefault();
        $(this.$refs.resendemail).click();
      }
    },
    change_type() {
      if ($(this.$refs.pwd)[0].type == "text") {
        $(this.$refs.pwd)[0].type = "password";
        $(this.$refs.togglePassword).removeClass("fa-eye");
        $(this.$refs.togglePassword).addClass("fa-eye-slash");
      } else {
        $(this.$refs.pwd)[0].type = "text";
        $(this.$refs.togglePassword).removeClass("fa-eye-slash");
        $(this.$refs.togglePassword).addClass("fa-eye");
      }
    },
    showEmail() {
      if (this.action2 != "4" && this.action2 != "1") {
        if (window.location.href.indexOf("uat") > -1){
          if (this.$i18n.locale == "en") {
            window.open(k11config.kdp_uat_forgetpassword_en, "_blank").focus();
          } else if (this.$i18n.locale == "zh_CN") {
            window.open(k11config.kdp_uat_forgetpassword_zh_cn, "_blank").focus();
          } else if (this.$i18n.locale == "zh_HK") {
            window.open(k11config.kdp_uat_forgetpassword_zh_hk, "_blank").focus();
          }
        }else{
          if (this.$i18n.locale == "en") {
            window.open(k11config.kdp_forgetpassword_en, "_blank").focus();
          } else if (this.$i18n.locale == "zh_CN") {
            window.open(k11config.kdp_forgetpassword_zh_cn, "_blank").focus();
          } else if (this.$i18n.locale == "zh_HK") {
            window.open(k11config.kdp_forgetpassword_zh_hk, "_blank").focus();
          }
        }
        
      } else {
        this.forgetemail = "";
        this.disabled2 = true;
        $("#confirmBox").modal("show");
      }
    },
    showBind() {
      this.pwd = "";
      $("#confirmBox2").modal("show");
    },
    test() {
      if (this.count > 4) {
        this.disabled = true;
        $(this.$refs.pw_error)[0].innerText = this.$t(
          "You have exceed the maximum number of trials for entering password, please try again later"
        );
      } else {
        this.count++;
        $(this.$refs.pw_error)[0].innerText = this.$t(
          "The password entered is incorrect, please try again"
        );
      }
      this.spinner = false;
      $(this.$refs.loading)[0].innerText = this.$t("Login");
      $(this.$refs.load).css("z-index", 0);
    },
    sumbit() {
      let vm = this;
      $(this.$refs.load).css("z-index", "2147483647");
      $(this.$refs.loading)[0].innerText = this.$t("Loading") + " ...";
      this.spinner = true;

      $.ajax({
        method: "POST",
        contentType: "application/json",
        url: config.serverURI + "/migrationhub/member/verification",
        data: JSON.stringify({
          action: this.action,
          mobile_phone_country: this.country_code,
          account_value_detail: this.phone,
          account_type: 2,
          verify_type: 1,
          verify_value: this.pwd,
          k11_vip_account_no: this.k11accountno || "",
          klub11_vip_code: this.k11vipcode || "",
          kdp_member_id: this.kdpmembernumber || "",
        }),
        complete: function (data3) {
          vm.spinner = false;

          if (data3.responseJSON != null) {
            if (data3.responseJSON.success) {
              // Member identifiers are only available now, after the
              // OTP/password verification succeeded.
              const vdata = data3.responseJSON.data;
              if (vdata.klub11_vip_code) vm.k11vipcode = vdata.klub11_vip_code;
              if (vdata.klub11_vip_account_number) vm.k11accountno = vdata.klub11_vip_account_number;
              if (vdata.kdp_member_id) vm.kdpmembernumber = vdata.kdp_member_id;
              vm.k11vipcode = vm.k11vipcode || "";
              vm.k11accountno = vm.k11accountno || "";
              vm.kdpmembernumber = vm.kdpmembernumber || "";
              window.sessionStorage.setItem(
                "phone",
                data3.responseJSON.data.phone
              );
              window.sessionStorage.setItem(
                "country_code",
                data3.responseJSON.data.country_code
              );
              window.sessionStorage.setItem(
                "session",
                data3.responseJSON.data.session
              );
              if (vm.action2 == 2) {
                window.sessionStorage.setItem(
                  "kdpmembernumber",
                  vm.kdpmembernumber
                );
                window.sessionStorage.setItem("action", 2);
                window.sessionStorage.setItem("iskdp", "1");
                window.sessionStorage.setItem("isk11", "0");
                vm.changeurl();
                window.location.href = "./#/register";
              } else if (vm.action2 == 1) {
                $.ajax({
                  method: "POST",
                  contentType: "application/json",
                  url: config.serverURI + "/migrationhub/captcha",
                  data: JSON.stringify({
                    parameters: {
                      receiver_value: {
                        country_code: vm.country_code,
                        value: vm.phone,
                        kdp_member_number: "",
                      },
                      receiver_type: 2,
                      type: 2,
                      action: 0,
                    },
                  }),
                  complete: function (jdata2) {
                    if (jdata2.responseJSON != null) {
                      if (jdata2.responseJSON.success) {
                        window.sessionStorage.setItem(
                          "k11vipcode",
                          vm.k11vipcode
                        );
                        window.sessionStorage.setItem(
                          "k11accountno",
                          vm.k11accountno
                        );
                        window.sessionStorage.setItem("action2", 5);
                        window.sessionStorage.setItem("action", 0);
                        window.sessionStorage.setItem("iskdp", 0);
                        window.sessionStorage.setItem("isk11", 1);
                        window.sessionStorage.setItem("kdpmembernumber", "");
                        vm.changeurl();
                        window.location.href = "./#/validation";
                      }
                    } else {
                      vm.errormessage = vm.$t("Network error");
                      $("#ReminderBox").modal("show");
                      vm.spinner = false;
                      $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                      $(vm.$refs.load).css("z-index", 0);
                    }
                  },
                });
              } else if (vm.action2 == 4) {
                helper.loading();
                $.ajax({
                  method: "POST",
                  contentType: "application/json",
                  url: config.serverURI + "/migrationhub/captcha",
                  data: JSON.stringify({
                    parameters: {
                      receiver_value: {
                        country_code: vm.country_code,
                        value: vm.phone,
                        kdp_member_number: vm.kdpmembernumber,
                      },
                      receiver_type: 2,
                      type: 1,
                      action: 0,
                      klub11_vip_code: vm.k11vipcode,
                    },
                  }),
                  complete: function (jdata) {
                    if (jdata.responseJSON != null) {
                      if (jdata.responseJSON.success) {
                        window.sessionStorage.setItem("action2", 6);
                        window.sessionStorage.setItem(
                          "k11vipcode",
                          vm.k11vipcode
                        );
                        window.sessionStorage.setItem(
                          "k11accountno",
                          vm.k11accountno
                        );
                        window.sessionStorage.setItem(
                          "kdpmembernumber",
                          vm.kdpmembernumber
                        );
                        window.sessionStorage.setItem("action", 0);
                        window.sessionStorage.setItem(
                          "sms_log_id",
                          jdata.responseJSON.data.sms_log_id
                        );
                        helper.done();
                        vm.changeurl();
                        window.location.href = "./#/validation";
                      } else {
                        vm.errormessage =
                          vm.$t("Something went wrong") +
                          // " " +
                          // vm.$t("Please try again later") +
                          " " +
                          jdata.responseJSON.msg[
                            helper.getMappingLocale(vm.$i18n.locale)
                          ] +
                          "(" +
                          jdata.responseJSON.errorcode +
                          ")";
                        $("#ReminderBox").modal("show");
                        helper.done();
                      }
                    } else {
                      vm.errormessage = vm.$t("Network error");
                      $("#ReminderBox").modal("show");
                      helper.done();
                    }
                  },
                });
              } else if (vm.action2 == 0) {
                window.sessionStorage.setItem(
                  "kdpmembernumber",
                  vm.kdpmembernumber
                );
                window.sessionStorage.setItem("k11vipcode", vm.k11vipcode);
                window.sessionStorage.setItem("k11accountno", vm.k11accountno);

                vm.changeurl();
                window.location.href = "./#/bind";
              }
            } else {
              vm.test();
            }
          } else {
            vm.errormessage = vm.$t("Network error");
            vm.spinner = false;
            $("#ReminderBox").modal("show");
            $(vm.$refs.load).css("z-index", 0);
            $(vm.$refs.loading)[0].innerText = vm.$t("Login");
          }
        },
      });
    },
  },
};
</script>
